import { render, staticRenderFns } from "./UploadFileTalent.vue?vue&type=template&id=5caa99df&scoped=true&"
import script from "./UploadFileTalent.vue?vue&type=script&lang=js&"
export * from "./UploadFileTalent.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileTalent.vue?vue&type=style&index=0&id=5caa99df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa99df",
  null
  
)

export default component.exports